import {
  Alert,
  AlertColor,
  Button,
  Snackbar,
  SnackbarOrigin,
  Typography,
} from "@mui/material";
import { requestNotificationStyles } from "styles/RequestNotification.styles";

type RequestNotificationProps = {
  open: boolean;
  message: string;
  onClose: () => void;
  title?: string;
  severity?: AlertColor;
  autoHideDuration?: number;
  actionLabel?: string;
  onAction?: () => void;
  anchorOrigin?: SnackbarOrigin;
};

const RequestNotification = ({
  open,
  message,
  onClose,
  title,
  severity = "error",
  autoHideDuration = 4000,
  actionLabel,
  onAction,
  anchorOrigin = { vertical: "top", horizontal: "right" },
}: RequestNotificationProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      sx={requestNotificationStyles.snackbar}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={requestNotificationStyles.alert}
        action={
          actionLabel && onAction ? (
            <Button color="inherit" size="small" onClick={onAction}>
              {actionLabel}
            </Button>
          ) : undefined
        }
      >
        {title ? (
          <Typography variant="body2" sx={requestNotificationStyles.title}>
            {title}
          </Typography>
        ) : null}
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default RequestNotification;
